import { browserHistory } from 'react-router'

import { connect } from 'react-redux'

import generator from 'generate-password'

import {
  setData,
  setError,
  setUser,
  setProfile,
  getValidateEmail,
  setErrorClean,
} from 'reduxpath/ducks/AdminCreatedUser/Add'

import { buildEmail } from 'utils/BuildEmail'

import { postEmail } from 'reduxpath/ducks/Email'

import { getValidateProfile } from 'reduxpath/ducks/Profile'

import {
  setSelectedCountry,
  setSelectionsCity,
  getCitiesByCountryId,
} from 'reduxpath/ducks/Reference'

import Add from './units'

const mapStateToProps = state => ({
  firstName: state.AdminCreatedUserAdd.data.firstName,
  lastName: state.AdminCreatedUserAdd.data.lastName,
  email: state.AdminCreatedUserAdd.data.email,
  password: state.AdminCreatedUserAdd.data.password,
  source: state.AdminCreatedUserAdd.data.source,

  profileId: state.AdminCreatedUserAdd.data.profileId,
  profileName: state.AdminCreatedUserAdd.data.profileName,
  city: state.AdminCreatedUserAdd.data.city,
  country: state.AdminCreatedUserAdd.data.country,
  defaultFeature: state.AdminCreatedUserAdd.data.defaultFeature,

  isError: state.AdminCreatedUserAdd.isError,
  isEmailExists: state.AdminCreatedUserAdd.isEmailExists,
  errorMessage: state.AdminCreatedUserAdd.errorMessage,

  selectionsCountry: state.Reference.selectionsCountry,
  selectedCountry: state.Reference.selectedCountry,
  selectionsCity: state.Reference.selectionsCity,
  selectedCity: state.Reference.selectionsCity,

  param: {
    user: {
      firstName: state.AdminCreatedUserAdd.data.firstName,
      lastName: state.AdminCreatedUserAdd.data.lastName,
      email: state.AdminCreatedUserAdd.data.email,
      password: state.AdminCreatedUserAdd.data.password,
      source: state.AdminCreatedUserAdd.data.source,
    },
    profile: {
      profileId: state.AdminCreatedUserAdd.data.profileId,
      name: state.AdminCreatedUserAdd.data.profileName,
      city: state.AdminCreatedUserAdd.data.city,
      country: state.AdminCreatedUserAdd.data.country,
      defaultFeature: state.AdminCreatedUserAdd.data.defaultFeature,
    },
    email: {
      adminEmail: state.Auth.me.user.email,
      adminName: state.Auth.me.user.firstName,
    },
  },
})

const mapDispatchToProps = dispatch => ({
  onInputChange(data) {
    if (data.name !== 'profileId') {
      dispatch(setData({
        [data.name]: data.value,
      }))
    }
    if (data.name === 'profileId') {
      const profileId = data.value.replace(/\s+/g, '').toLowerCase()
      dispatch(setData({
        [data.name]: profileId,
      }))
    }
  },

  generatePassword(e) {
    e.preventDefault()
    dispatch(setData({
      password: generator.generate({
        length: 8,
        numbers: true,
        excludeSimilarCharacters: true,
        uppercase: true,
        symbols: false,
      }),
    }))
  },

  handleSelectedCountry(e) {
    const countryId = e.target.value

    dispatch(setData({ country: countryId }))
    dispatch(setSelectedCountry(countryId))
    dispatch(getCitiesByCountryId(countryId, null, (res) => {
      dispatch(setSelectionsCity(res.rows))
    }))
  },

  submitForm(param) {
    return (e) => {
      e.preventDefault()
      const { email } = param.user
      dispatch(getValidateEmail(email, (res) => {
        const hasEmail = res.count
        if (hasEmail > 0) {
          return dispatch(setError({
            message: 'Email address is taken, choose another.',
          }))
        }
        const { profileId, country, city, defaultFeature } = param.profile
        const { password } = param.user
        if (password === '') {
          return dispatch(setError({
            message: 'Have you clicked the auto-generate password button yet?',
          }))
        }
        if (country === '') {
          return dispatch(setError({
            message: 'You need to select a country, you know?',
          }))
        }
        if (city === '') {
          return dispatch(setError({
            message: 'You definitely need to pick up the city first.',
          }))
        }
        if (profileId.length < 4) {
          return dispatch(setError({
            message: 'Profile ID needs to have at least 4 characters ;)',
          }))
        }
        if (defaultFeature === '') {
          return dispatch(setError({
            message: 'You need to select the default-feature of your user.',
          }))
        }
        return dispatch(getValidateProfile(profileId, (response) => {
          const found = response
          if (found === 1) {
            return dispatch(setError({
              message: 'Profile ID has been used, please choose another.',
            }))
          }
          dispatch(setErrorClean)
          const userParams = param.user

          return dispatch(setUser(userParams, (user) => {
            const userId = { user: user.id }
            const profileParams = { ...userId, ...param.profile }
            const params = { ...userParams, ...param.email }

            const handlebars = {
              adminEmail: params.adminEmail,
              adminName: params.adminName,
              email: params.email,
              name: params.firstName,
              tempPassword: params.password,
            }
            const emailData = {
              recipient: [{
                name: params.firstName,
                email: params.email,
              }],
              category: 'registration-by-admin',
              type: 'both',
              handlebars,
            }
            dispatch(postEmail(buildEmail(emailData)))
            return dispatch(setProfile(profileParams, () => browserHistory.push('/admin-created-user')))
          }))
        }))
      }))
    }
  },

})

function mergeProps(stateProps, dispatchProps) {
  return {
    ...stateProps,
    ...dispatchProps,
    submitForm: dispatchProps.submitForm(
      stateProps.param,
    ),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(Add)
